import './Navbar.scss'

import {HiX, HiMenuAlt4} from 'react-icons/hi'
import React, {useState} from 'react'
import {motion} from 'framer-motion'
import { useTheme } from '../../context/ThemeContext'
import { CiLight, CiDark } from "react-icons/ci";

const Navbar = () => {
  const [toggle, setToggle] = useState(false)
  const {theme, toggleTheme} = useTheme()
  
  return (
  <nav className='app__navbar'>
    <div className='app__navbar-logo' onClick={toggleTheme}>
      { theme ? <CiDark size={30} /> : <CiLight size={30} /> }
    </div>


    <ul className='app__navbar-links'>
      {['home','about','work','skills','contact'].map(item => (
        <li key={`link-${item}`} className='p-text'>
          <div/>
          <a href={`#${item}`}>{item}</a>
        </li>
      ))}
    </ul>

    <div className='app__navbar-menu'>
      <HiMenuAlt4 onClick={() => setToggle(true)}/>
      
        {toggle && (
          <motion.div
            whileInView={{x: [200,0]}}
            transition={{duration: 0.85, ease: 'easeOut'}}
          >
            <HiX onClick={() => setToggle(false)} />  
            <ul>
              {['home','about','work','skills','contact'].map(item => (
                <li key={item} >
                  <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                </li>
              ))}
            </ul>  
          </motion.div>
        )} 
    </div>
  </nav>
  )
}

export default Navbar